import Vue from 'vue';
import Vuex from 'vuex';
import jwtDecode from "jwt-decode";

Vue.use(Vuex);

const checkToken = token => {
  try {
    const { exp, data: user } = jwtDecode(token);
    const dt = Math.floor(new Date()/1000);
    if (exp<dt) {
      localStorage.removeItem(token);
      return {};
    }
    return { token, user };
  } catch (e) {
    localStorage.removeItem(token);
    return {};
  }
}

const { token, user } = checkToken(localStorage.getItem('token'));

const defaultSnackbar = {
  display: false,
  text: '',
  color: 'error',
  close: true,
};

const store = new Vuex.Store({
  state: {
    auth: {
      token, user
    },
    projects: undefined,
    snackbar: defaultSnackbar
  },
  getters: {
    user: state => state.auth.user,
    projects: state => state.projects,
    snackbar: state => state.snackbar,
  },
  mutations: {
    authSuccess(state, rawToken) {
      const { token, user } = checkToken(rawToken);
      if (token && user) {
        Vue.prototype.$http.defaults.headers.common.Authorization = `Bearer : ${token}`;
        state.auth = { token, user };
      }
    },
    logout(state) {
      state.auth.token = undefined;
      Vue.prototype.$http.defaults.headers.common.Authorization = undefined;
      localStorage.removeItem('token');
    },
    projects(state, projects) {
      state.projects = projects;
    },
    addProject(state, project) {
      state.projects = [project, ...state.projects];
    },
    snackbar(state, snackbar) {
      state.snackbar = snackbar;
    },
  },
  actions: {
    authSuccess({ commit }, token) {
      commit('authSuccess', token);
    },
    logout({ commit }) {
      commit('logout');
    },
    setProjects({ commit }, projects) {
      commit('projects', projects);
    },
    closeSnackbar({commit}) {
      commit('snackbar', defaultSnackbar);
    },
    addProject({ commit }, project) {
      commit('addProject', project);
    },
    snackbar({commit}, snackbar) {
      commit('snackbar', { ...defaultSnackbar, ...snackbar, display: true});
    }
  },
});

export default store;
